import request from '@/utils/request'
import Cookies from 'js-cookie'
import moment from "moment";
import { parseTime } from '@/utils'

/**
 * 获取用户基本信息（cookie中取，如果没有就先获取数据再保存到cookie，过期时间为1小时后）
 * @param {*} query 参数
 */
const UserInfoKey = 'lshoot-qupaipai-hkm-userinfo'
export function getUserByCookie(query) {
  const userInfo = Cookies.get(UserInfoKey)
  if (userInfo) {
    return new Promise((resolve, reject) => {
      resolve(JSON.parse(userInfo))
    })
  }
  else {
    return getUser(query)
    // const response = request({
    //   url: '/User/GetUser',
    //   method: 'get',
    //   params: query
    // })
    // return new Promise((resolve, reject) => {
    //   response.then(res => {
    //     const { code, data } = res
    //     if (code >= 0 && data) {
    //       console.info('获取用户基本信息', data)
    //       Cookies.set(UserInfoKey, data, { expires: new Date(new Date().getTime() + 9 * 60 * 60 * 1000) });
    //     }
    //     resolve(data)
    //   }).catch(res => {
    //     reject(res)
    //   })
    // })
  }
}

/**
 * 获取用户基本信息
 * @param {*} query 
 */
export function getUser(query) {
  const response = request({
    url: '/User/GetUser',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data) {
        console.info('获取用户基本信息', data)
        data.birthday = data.birthday ? moment(data.birthday).format('YYYY-MM-DD') : null
        data.sex = `${data.sex}`
        Cookies.set(UserInfoKey, data, { expires: new Date(new Date().getTime() + 9 * 60 * 60 * 1000) });
      }
      resolve(data)
    }).catch(res => {
      reject(res)
    })
  })
}

// 更新用户信息
export function updateUser(data) {
  return request({
    url: '/User/UpdateUser',
    method: 'post',
    data
  })
}

// 修改密码
export function modifyPwd(data) {
  return request({
    url: '/User/ModifyPwd',
    method: 'post',
    data
  })
}

// 获取店铺收益分页数据
export function getStoreIncomePager(query) {
  const response = request({
    url: '/User/GetStoreIncomePager',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data.list) {
        data.list = data.list.map(item => {
          item.createTime = parseTime(item.createTime, '{y}-{m}-{d} {h}:{i}')
          return item
        })
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

// 获取店铺提现记录分页数据
export function getStoreExtractCashPager(query) {
  const response = request({
    url: '/User/GetStoreExtractCashPager',
    method: 'get',
    params: query
  })
  return new Promise((resolve, reject) => {
    response.then(res => {
      const { code, data } = res
      if (code >= 0 && data) {
        data.list = data.list.map(item => {
          item.createTime = parseTime(item.createTime, '{y}-{m}-{d} {h}:{i}')
          return item
        })
      }
      resolve(res)
    }).catch(res => {
      reject(res)
    })
  })
}

// 获取用户收益统计数据
export function getIncomeStatistics(query) {
  return request({
    url: '/User/GetIncomeStatistics',
    method: 'get',
    params: query
  })
}

// 绑定微信账号（openid）
export function weixinBind(openid) {
  return request({
    url: '/User/WeixinBind',
    method: 'post',
    data: { openid }
  })
}

// 获取客服问答列表
export function getQAService(query) {
  return request({
    url: '/User/GetQAServicePager',
    method: 'get',
    params: query
  })
}

//提交反馈数据
export function submitFeedback(query) {
  return request({
    url: '/User/AddFeedback',
    method: 'post',
    params: query
  })
}

// 获取oss签名
export function getOssAutograph() {
  return request({
    url: '/User/GetOssAutograph',
    method: 'get',
  })
}


// 主动绑定微信账号（openid）
export function bindWechat(data) {
  return request({
    url: '/User/BindWechat',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/m/user.js